
jQuery(document).ready(function($){
    // Alow numbers only
    $(".number-field").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
             // Allow: Ctrl+A, Command+A
            (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
             // Allow: home, end, left, right, down, up
            (e.keyCode >= 35 && e.keyCode <= 40)) {
                 // let it happen, don't do anything
                 return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });
    $(".main-nav").slimscroll({
        height: "92%",
        position: "right",
        size: "5px",
        color: "#9ea5ab",
        wheelStep: 5,
        touchScrollStep: 50
    })
    $(".pay-table-holder").slimscroll({
        height: "100%",
        position: "right",
        size: "5px",
        color: "#9ea5ab",
        wheelStep: 5,
        touchScrollStep: 50
    })
    $(".vertical-scroll").slimscroll({
        position: "right",
        size: "5px",
        color: "#9ea5ab",
        wheelStep: 5,
        touchScrollStep: 50
    })
    $(".recent-added-inner").slimscroll({
        position: "right",
        right: "10px",
        size: "7px",
        color: "#ea488a",
        opacity : 1,
        top: "8px",
        railColor: '#caced9',
        wheelStep: 5,
        height: "100%",
        touchScrollStep: 50,
        railVisible: true,
        alwaysVisible: true,
        distance: '5px',
        railOpacity: 1,
    })
    
    $('.header .desktop-small-menu .desktop-bars').click(function(){
        $('.sidebar').toggleClass('small-sidebar');
        $('.header').toggleClass('large-header');
        $('.main-cotent').toggleClass('large-content');
    })
    $('.header .mobile-bars').click(function(){
            $('.sidebar, .page-overlay').addClass('active');
            $('body').addClass('oveflow-hidden');
    })
    $('.page-overlay').click(function(){
        $('.sidebar, .page-overlay').removeClass('active');
    })

    var nav_link = $('.main-nav .nav-item .nav-link'),
    sub_nav = $('.main-nav .nav-item .sub-nav');

    nav_link.first().parent('.nav-item').addClass('active');
    nav_link.on('click', function(event) {
    if ($(this).parent('.nav-item').attr('class') != 'active'){
        $(this).next().stop(true,true).slideToggle('normal');
        nav_link.parent('.nav-item').removeClass('active');
        $(this).parent('.nav-item').addClass('active');
        $(this).parent('.nav-item').siblings().find('.sub-nav').slideUp();
    }
    });
    //switch button change
    $('#swither').on('change', function(){
        var profile;
        if ($('#swither').is(':checked') === true) {
            profile = 'COMPANY';
        }else{
            profile = 'EMPLOYEE';
        }
        axios.get('/api/updateCurrentProfile?profile='+profile).then(res=>{
            var re = /^https?:\/\/[^/]+/i;
            window.location.href = re.exec(window.location.href)[0];
        }).catch(err => {console.log(err);});
        //$('.sidebar').toggleClass('emp-sidebar');
    });
    if(typeof $('#swither').type !== 'undefined'){
        if ($('#swither').is(':checked')) {
            $('.sidebar').removeClass('emp-sidebar');
        }else{
            $('.sidebar').addClass('emp-sidebar');
        }
    }

    $(document).mouseup(function(e) {
        var container = $(".custom-drop-down");
        // if the target of the click isn't the container nor a descendant of the container

        if (!container.is(e.target) && container.has(e.target).length === 0)
        {
            container.removeClass('active');
        }
    });
});
